import React, { ChangeEvent, FC } from 'react'
import styles from 'styles/components/form.module.scss'

type Props = {
  disabled?: boolean
  max?: string
  min?: string
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  step?: number
  value: string
}

const DatetimePicker: FC<Props> = (props) => {
  const { disabled = false, max, min, onChange, step, value } = props

  return (
    <label className={styles.datetime__wrapper}>
      <input
        className={styles.datetime}
        disabled={disabled}
        max={max}
        min={min}
        onChange={(e) => onChange(e)}
        step={step}
        type={'datetime-local'}
        value={value}
      />
      <span className={styles.triangle} />
      <span className={styles.triangle_inverted} />
    </label>
  )
}

export default DatetimePicker
